import { createAction } from 'redux-actions';

export const setActiveOpportunity = createAction<boolean>('SET_ACTIVE_OPPORTUNITY');
